import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { ReactComponent as EditIcon } from "images/edit_blue.svg";
import { ReactComponent as GearIcon } from "images/gear.svg";
import { ReactComponent as DeleteIcon } from "images/trash.svg";

const columnHelper = createColumnHelper<any>();

export const getWeeks = (
  selectedWeek: string,
  handleWeekSelection: (weekStartDate: string) => void,
  handleDivisionSelection: (division: string) => void,
  isLoading: boolean,
  handleBuildWeek: (weekStartDate: string, division: string) => void,
  handleEdit: (weekStartDate: string, division: string, weekDescription: string, scheduleType: string) => void,
  handleDelete: (weekStartDate: string, division: string) => void) => [
    columnHelper.accessor("select", {
      header: "Select",
      size: 70,
      cell: ({ row }: any) => (
        <div className="">
          <input
            type="radio"
            name="selectedOrderRow"
            value="selected"
            checked={row.original.weekStartDate === selectedWeek}
            onChange={() => { }}
            onClick={() => {
              if (selectedWeek === row.original.weekStartDate) {
                handleWeekSelection("");
              } else {
                handleWeekSelection(row.original.weekStartDate);
                handleDivisionSelection(row.original.division);
              }
            }}
          />
        </div>
      ),
    }),

    columnHelper.accessor("weekStartDate", {
      header: "Week",
      size: 120,
      cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-',
    }),

    columnHelper.accessor("description", {
      header: "Description",
      size: 300,
      cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-',
    }),

    columnHelper.accessor("scheduleType", {
      header: "Type",
      size: 130,
      cell: info => info.getValue() ? <div>{info.getValue().toLowerCase().capitalize()}</div> : '-',
    }),


    columnHelper.accessor("action", {
      header: "Action",
      size: 100,
      cell: info => info.row.original.scheduleType !== 'MASTER' ? <div style={{ display: 'flex', gap: '8px' }}>
        <div title="Build Manifest" onClick={() => handleBuildWeek(info.row.original.weekStartDate, info.row.original.division)}><GearIcon className="clone-week-btn__icon" /></div>
        <div title="Edit" onClick={() => handleEdit(info.row.original.weekStartDate, info.row.original.division, info.row.original.description, info.row.original.scheduleType)}><EditIcon className="clone-week-btn__icon" /></div>
        <div title="Delete" onClick={() => handleDelete(info.row.original.weekStartDate, info.row.original.division)}><DeleteIcon className="clone-week-btn__delete_icon" /></div>
      </div> : '-',
    }),

  ];
